import s from "./ToggableButton.module.scss";
import React from "react";
import cn from "classnames";
import { IoIosClose } from "react-icons/io";
// import "./ToggableButton.css";
export interface IBenchmarkItem {
  label: string;
  value: string;
  color: string;
  disabled?: boolean;
}

interface IProps {
  item: IBenchmarkItem;
  onPress: (key: string) => void;
  onDelete: (e: React.MouseEvent<SVGElement, MouseEvent>, key: string) => void;
  active: boolean;
  hide?: boolean;
}

export const ToggableButton = ({
  item,
  onPress,
  active,
  onDelete,
  hide,
}: IProps) => {
  const selected = active || item.disabled;
  if (hide) return null;
  return (
    <div
      data-cy="ToggableButton"
      onClick={() => (item.disabled ? {} : onPress(item.value))}
      className={cn(
        s.itemContainer,
        selected && s.active,
        item.disabled && s.disabled
      )}
      style={{ backgroundColor: selected ? item.color : undefined }}
    >
      <div
        className={s.circle}
        style={{ backgroundColor: selected ? "white" : item.color }}
      />
      {item.label?.length > 0 ? (
        <span className={cn(s.legendItemName, selected && s.active)}>
          {item.label?.split(" – ")[0]?.split(" - ")[0]}
        </span>
      ) : (
        <div className={cn(s.shine)} />
      )}
      {!item.disabled && (
        <IoIosClose
          data-cy="ToggableButtonClose"
          onClick={(e) => onDelete?.(e, item.value)}
          className={s.close}
          color={selected ? "white" : undefined}
          size={18}
        />
      )}
    </div>
  );
};

export default ToggableButton;
